import { type StateType } from '../../states';
import { type ReviewState } from '../../types/review';
import { type Selector } from '../../types/selectors';

const emptyObj = {};

export const selectReviewState: Selector<ReviewState> = (state: StateType) => state.review ?? emptyObj;

export const selectReviewIsDialogOpen: Selector<boolean> = (state: StateType) =>
  selectReviewState(state)?.isDialogOpen ?? false;
